import React from 'react';

const LeftPanel = ({ isSmartplugMode = false }) => {
  return (
    <div
      className={`tw-bg-base-yellow max-width-left-panel  tw-flex tw-flex-col tw-justify-between tw-overflow-hidden ${
        isSmartplugMode ? 'tw-w-2/5' : 'tw-w-3/5'
      }`}
    >
      <div
        className={`tw-flex tw-flex-col tw-items-start ${
          isSmartplugMode ? 'tw-ml-16' : 'tw-ml-32'
        } tw-mt-48`}
      >
        <img
          src='https://b.zmtcdn.com/data/o2_assets/211fb6358091191d3b5b213d8df4fdb21675246365.png'
          alt='blinkit-logo'
          className={isSmartplugMode ? 'tw-w-[10rem]' : 'tw-w-[12rem]'}
        />
        <div
          className={`tw-font-medium ${
            isSmartplugMode ? 'tw-text-[6rem]' : 'tw-text-[8rem]'
          } tw-leading-none tw-m-0 tw-p-0 tw-tracking-[-3px] -tw-ml-2 tw-text-base-black`}
        >
          Lifeline
        </div>
        <div
          className={`tw-font-medium ${
            isSmartplugMode
              ? 'tw-text-[1.6rem] tw-mt-6'
              : 'tw-text-[2rem] tw-mt-10'
          } tw-leading-none tw-w-4/5 tw-text-base-black`}
        >
          The unified platform for Blinkit customer support operations.
        </div>
      </div>

      <img
        src='https://b.zmtcdn.com/data/o2_assets/f4c48d11ffb57d80267e9c4ea0e7284e1675267676.png'
        alt='operations-team-image'
        className={
          isSmartplugMode
            ? 'tw-w-[40rem] tw-mx-auto tw-opacity-80 -tw-mb-10'
            : 'tw-w-[60rem] tw-mx-auto tw-opacity-80 -tw-mb-10'
        }
      />
    </div>
  );
};

export default LeftPanel;
